// Sayfa key → Türkçe etiket. MainLayout topbar + Dashboard ActiveUsersWidget kullanıyor.
const PAGE_TITLES = {
  'custom-fields': 'Özel Alanlar',
  'crm-pipeline':  'CRM Pipeline',
  'prospect-accounts': 'Potansiyel Cariler',
  'lead-form-embed': 'Web Lead Form',
  'projects': 'Projeler',
  'ecom-orders': 'E-Ticaret Siparişleri',
  'ecom-catalog-embed': 'E-Ticaret Katalog Kodu',
  'lost-reasons': 'Kaybedilme Nedenleri',
  'sales-targets': 'Satış Hedefleri',
  'rfq': 'RFQ (Toplu Teklif)',
  'reorder-suggestions': 'Sipariş Önerileri',
  'babs-report': 'BA / BS Formu',
  dashboard: 'Ana Sayfa', stocks: 'Stok / Ürünler', accounts: 'Cari Hesaplar',
  stokislemleri: 'Stok İşlemleri', stockseries: 'Stok Seri Tanımları', colorsizewizard: 'Renk / Beden Sihirbazı',
  personelislemleri: 'Personel İşlemleri', plasiyerroutes: 'Plasiyer Rotaları', plasiyerdaily: 'Günlük Saha Ziyaretleri',
  commissions: 'Prim / Hakediş Raporu',
  'personnel-alacak': 'Personel Alacak Dekontu',
  'personnel-borc':   'Personel Borç Dekontu',
  cariislemleri: 'Cari İşlemler',
  'cari-acilis': 'Cari Açılış Fişi',
  'cari-borc':   'Cari Borç Dekontu',
  'cari-alacak': 'Cari Alacak Dekontu',
  'cari-virman': 'Cari Virman Dekontu',
  'cari-tahsilat': 'Cari Tahsilat Makbuzu',
  cekislemleri: 'Çek-Senet İşlemleri',
  'cek-portfoy': 'Çek Kartı (Alınan)',
  'cek-verilen': 'Çek Kartı (Verilen)',
  'senet-portfoy': 'Senet Kartı (Alınan)',
  'senet-verilen': 'Senet Kartı (Verilen)',
  satisiade: 'Satış / İade Faturaları', sales: 'Satış Faturası', 'sales-returns': 'Satış İade Faturası',
  alisiade: 'Alış / İade Faturaları', purchases: 'Alış Faturası', 'purchases-returns': 'Alış İade Faturası',
  warehouses: 'Depo Tanıtım Kartı', branches: 'Şube Tanıtım Kartı', campaigns: 'Kampanyalar', personnel: 'Personel',
  'balance-check': 'Bakiye Tutarlılık Kontrolü',
  exchange: 'Kur Takibi', settings: 'Ayarlar',
  programtanimlari: 'Program Tanımları',
  platformkargo: 'Platform / Kargo Tanımları',
  bankislemleri: 'Banka İşlemleri', bankaccounts: 'Banka Hesapları',
  kasaislemleri: 'Kasa İşlemleri', cashregisters: 'Kasa Hareketleri',
  'cash-acilis': 'Kasa Açılış Fişi', 'cash-virman': 'Kasa Virman Dekontu', cashdef: 'Kasa Tanıtım Kartı',
  'expense-vouchers': 'Gider Fişleri',
  'expense-cards': 'Firma Kredi Kartları',
  'bank-acilis': 'Banka Açılış Fişi', 'bank-alacak': 'Banka Alacak Dekontu',
  'bank-borc': 'Banka Borç Dekontu', 'bank-virman': 'Banka Virman Dekontu',
  'bank-pos': 'Banka POS Kartları',
  'bank-pos-slips': 'POS Slip Tahsilat',
  'cari-vouchers': 'Alış Veriş Çekleri',
  auditlog: 'İşlem Geçmişi (LOG)',
  fiscalperiods: 'Çalışma Dönemleri',
  users: 'Kullanıcılar',
  roles: 'Roller ve İzinler',
  subscription: 'Aboneliğim',
  pricedefinitions: 'Fiyat Tanımları',
  accounting: 'Muhasebe',
  'acc-chart': 'Hesap Planı (TDHP)',
  'acc-mappings': 'Hesap Eşleme Tablosu',
  appointments: 'Randevu / Ajanda',
  messages: 'Mesajlar',
  support: 'Destek Talepleri',
  'ai-analysis': 'AI Veri Analizi',
  'reports-stocks':    'Stok Raporları',
  'reports-accounts':  'Cari Raporları',
  'quotes-incoming':   'Alınan Teklifler',
  'quotes-outgoing':   'Verilen Teklifler',
  'orders-incoming':   'Alınan Siparişler',
  'orders-outgoing':   'Verilen Siparişler',
  'waybills-purchase': 'Alış İrsaliyesi',
  'waybills-sales':    'Satış İrsaliyesi',
  'reports-banks':     'Banka Raporları',
  'reports-personnel': 'Personel Raporları',
  'reports-invoices':  'Fatura Raporları',
  'stock-labels':      'Barkod Etiket Dökümü',
  'label-templates':   'Etiket Şablonları',
  'label-designer':    'Etiket Tasarım',
  belgeonaylari:       'Belge Onayları',
  'pending-approvals': 'Bekleyen Onaylar',
  'approved-documents':'Onaylanan Belgeler',
  ebelgeyonetimi: 'E-Belge Yönetimi',
  'ebelge-incoming-invoices': 'Gelen Fatura (e-Belge)',
  'ebelge-outgoing-invoices': 'Giden Fatura (e-Belge)',
  'ebelge-incoming-waybills': 'Gelen İrsaliye (e-Belge)',
  'ebelge-outgoing-waybills': 'Giden İrsaliye (e-Belge)',
  // Vendor sayfaları
  'vendor-dashboard':    'Vendor Dashboard',
  'vendor-companies':    'Müşteri Firmalar',
  'vendor-leads':        'Lead\'ler & Pipeline',
  'vendor-tickets':      'Destek Talepleri',
  'vendor-messages':     'Müşteri Mesajları',
  'vendor-plans':        'Abonelik Planları',
  'vendor-payment-methods': 'Ödeme Yöntemleri',
  'vendor-reports':      'Raporlar & Analitik',
  'vendor-team':         'Kullanıcı Tanımları',
  'vendor-settings':     'Vendor Ayarları',
  'vendor-customer-detail': 'Müşteri Detayı',
};

// Sayfa başlığı — current i18n dilinde döner.
// navMap.js Türkçe→İngilizce sözlüğü üzerinden çevirir; eşleşme yoksa TR aynen.
import i18n from '../i18n';
import { navLabel } from '../i18n/navMap';

export function pageTitle(key) {
  if (!key) return '';
  const tr = PAGE_TITLES[key] || key;
  return navLabel(tr, i18n.language);
}

export default PAGE_TITLES;
